import React from "react"
import PropTypes from "prop-types"
import Link from "../UI/Link/Link"
import Image from "../UI/Image/Image"
import ProfileSvg from "../../assests/icons/ProfileSvg"
import HoverProfileSvg from "../../assests/icons/HoverProfileSvg"

const ProfileTeams = props => {
  const { profileCollectionCollection, style } = props
  return (
    <div className={style?.profileSectionWrapper}>
      <div className={style?.profileSection}>
        {profileCollectionCollection?.items?.map((data, index) => {
          return (
            <div className={style?.profileWrapper} key={index}>
              <Link url={data?.link?.url} ariaLabel={data?.link?.ariaLabel}>
                <div className={style?.profileShapePic}>
                  <ProfileSvg color={data?.svgColor} />
                  <HoverProfileSvg color={data?.svgColor} />
                  <Image
                    className={style?.profileImg}
                    contentfulImage={data?.images?.imageDesktop}
                    alt={data?.images?.altText}
                  />
                </div>
              </Link>
              <div className={style?.profileName}>{data?.title}</div>
              <div className={style?.profileDesignation}>{data?.text}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
ProfileTeams.propTypes = {
  profileCollectionCollection: PropTypes.object,
  style: PropTypes.object,
}
export default ProfileTeams
